module.exports = __webpack_public_path__ + "img/49F7B6A3.f90adb89.png";